/** Product name shown in sidebar header subtitle when agency name is absent. */
export const PRODUCT_DISPLAY_NAME = 'NextFollowUp';

/** Firm logo (sidebar + browser tab). Served from /public. */
export const APP_LOGO_URL = `${process.env.PUBLIC_URL || ''}/nextfollowup-logo.png?v=3`;

/** Sidebar subtitle: agency name when set, otherwise product name. */
export function getSidebarBrandTitle(agency) {
  const name = (agency?.agencyName ?? '').trim();
  return name || PRODUCT_DISPLAY_NAME;
}
